import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const TcpUdp = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="TCP and UDP"
    videos={[
      "https://www.youtube.com/embed/KY_Bqp2xDVc?si=JGVLJ0g9sMyuqUEX"
    ]}
    takeaways={[]}
    questions={[
      "1) Consider two devices which wants to perform process-to-process communication without establishing a connection. Examine the header format for this type of service and also state its advantages and disadvantages."
    ]}
    exampleVideos={[]}
  />
);
}

export default TcpUdp;
